import React, { useState } from "react";
import Login from "../../components/Login";
import background from "../../assets/img/background.png";
import backdrop from "../../assets/img/overlay.png";
import logo1 from "../../assets/img/logo1.png";
import { Link } from "react-router-dom";

function Index() {
  const [showLogin, setShowLogin] = useState(false);

  return (
    <>
      <style>
        {`
        .footer {
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
          padding: 0px;
          font-size: 14px;
          color: #fff;
          text-align: center;
          background: transparent;
          z-index: 9999;
        }
        .footer a {
          color: #fff;
          text-decoration: none;
        }
        .footer a:hover {
          text-decoration: none;
        }

        @media (max-width: 768px) {
          .container {
            flex-direction: column;
            width: 95%;
            height: auto;
          }

          .gambar {
            display: none;
          }

          .deskripsi {
            padding: 20px;
          }

          .logo-jeneponto {
            width: 120px !important;
          }

          .masuk {
            font-size: 20px !important;
          }

          /* Tambahan: samakan ukuran font "Tidak memiliki akun?" dengan "Silakan hubungi Madrasah" */
          .text-small-mobile {
            font-size: 12px !important;
          }
        }

        .form-login-container {
          text-align: left !important;
        }

        .form-login-container label {
          display: block;
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 5px;
          color: #000;
        }

        .form-login-container input {
          width: 100%;
          padding: 10px;
          border-radius: 8px;
          border: 1px solid #ccc;
          margin-bottom: 15px;
        }

        .form-login-container button {
          width: 100%;
          background-color: #0c4a85;
          color: white;
          padding: 10px;
          border: none;
          border-radius: 8px;
          font-weight: bold;
          cursor: pointer;
        }

        .form-login-container button:hover {
          background-color: #06366a;
        }

        @keyframes marquee {
          0% {
            transform: translateX(100%);
          }
          100% {
            transform: translateX(-100%);
          }
        }

        .running-text {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          background: #fff;
          z-index: 9999;
          border-bottom: 1px solid #eee;
          overflow: hidden;
        }

        .running-text-inner {
          display: inline-block;
          white-space: nowrap;
          padding: 8px 0;
          animation: marquee 16s linear infinite;
          font-weight: 600;
          cursor: pointer;
          color: #0066DA;
          text-decoration: none;
        }
      `}
      </style>

      <div className="running-text">
        <Link to="/skl" className="running-text-inner">
          Pengumuman Kelulusan Siswa/i Madrasah Sumbar Silahkan klik disini
        </Link>
      </div>
      {/* Wrapper utama */}
      <div className="col-12 hero-container" style={{ minHeight: "100vh", position: "relative" }}>
        {/* Background */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.3) 81.78%, rgba(255, 255, 255, 0) 95.16%), url(${background})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            zIndex: -1,
          }}
        ></div>

        {/* Kontainer Login */}
        <div className="col-12 hero">
          <div
            className="container"
            style={{
              display: "flex",
              flexDirection: "row",
              backgroundColor: `rgba(255, 255, 255, 0.5)`,
              borderRadius: "15px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
              overflow: "hidden",
              position: "absolute",
              top: "48.5%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "850px",
              maxWidth: "100%",
              minHeight: "300px",
            }}
          >
            {/* Gambar kiri */}
            <div className="gambar" style={{ flex: 1, position: "relative" }}>
              <img
                src={backdrop}
                alt="Poster Bupati"
                style={{
                  width: "100%",
                  height: "100%",
                  marginLeft: "-9px",
                  objectFit: "cover",
                  filter: "brightness(0.8)",
                  backgroundColor: `hsla(214, 91%, 14%, 0.50)`,
                }}
              />
            </div>

            {/* Form login */}
            <div
              className="deskripsi"
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                padding: "25px 20px",
              }}
            >
              <div style={{ textAlign: "center", marginBottom: "15px" }}>
                <img
                  src={logo1}
                  alt="Logo Geschool"
                  className="logo-jeneponto"
                  style={{ width: "80px", height: "auto" }}
                />
              </div>

              <div style={{ textAlign: "justify" }}>
                <p
                  className="masuk"
                  style={{
                    fontSize: "32px",
                    fontWeight: "bold",
                    color: "#000",
                    marginBottom: "1px",
                    marginTop: "0",
                  }}
                >
                  Masuk
                </p>
                <span style={{ fontSize: "14px", color: "#000", display: "block" }}>
                  Silakan masuk menggunakan akun anda
                </span>
              </div>

              <div className="form-login-container">
                <Login />
              </div>

              <div style={{ textAlign: "center" }}>
                <p
                  className="text-small-mobile"
                  style={{
                    fontSize: "12px",
                    color: "#000",
                    marginBottom: "4px",
                    marginTop: "0",
                  }}
                >
                  Tidak memiliki akun?
                </p>
                <span
                  style={{
                    fontSize: "12px",
                    color: "#000",
                    display: "block",
                    marginTop: "0",
                  }}
                >
                  Silakan hubungi Madrasah
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Modal login */}
        {showLogin && (
          <div
            onClick={() => setShowLogin(false)}
            style={{
              position: "fixed",
              backdropFilter: "blur(4px)",
              top: 0,
              bottom: 0,
              right: 0,
              left: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
          >
            <div
              style={{ maxWidth: "500px", width: "100%" }}
              onClick={(e) => e.stopPropagation()}
            >
              <Login />
            </div>
          </div>
        )}
      </div>

      {/* Footer di luar hero-container */}
      <div className="footer">
        <a
          className="text-white"
          href="https://halteng.geschool.net/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Kanwil Kemenag Provinsi Sumatera Barat 2025
        </a>
      </div>
    </>
  );
}

export default Index;
